<app-ui-alert-host />
<router-outlet />
<ng-template #drawerCarrito>
    <app-cart-drawer></app-cart-drawer>
</ng-template>